import { render } from "./AppLayoutDefault.vue?vue&type=template&id=2ea7158c"
import script from "./AppLayoutDefault.vue?vue&type=script&lang=js"
export * from "./AppLayoutDefault.vue?vue&type=script&lang=js"

import "./AppLayoutDefault.vue?vue&type=style&index=0&id=2ea7158c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__